/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
  * Datetime string along with the timezone abbrevation is sent
  * If datetime and timezone is present it formats the date and appends the timezone abbrevation
  * @param date All the roles of the logged in user
  * @param timezone All the roles of the logged in user
**/
import moment from "moment/moment";

export function formatDate(date, timezone){
  if(!date || !timezone) return '-'

  try {
  const formatted = moment.parseZone(date).format("MM/DD/YYYY h:mm A");
  return `${formatted} (${timezone})`;
  } catch (err) {
  return "-";
  }
}
